import { ls_vars } from "Library/Constants";
import { getLocalStorage } from "Network/ApiService";
import { LOGOUT_PAGE } from "Network/ApiUrl";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store";
import { initializeAuthAction } from "store/Slices/authReducer";

export const useAuth = () => {
  const accessToken: string | null = getLocalStorage(ls_vars.ACCESS_TOKEN);

  const dispatch = useDispatch();
  const { isLoading, userData, userPreferences, isSuperAdmin, error } =
    useSelector((state: RootState) => state.auth);

  const initializeAuth = () => {
    dispatch(initializeAuthAction());
  };

  const logout = () => {
    localStorage.clear();
    location.href = LOGOUT_PAGE;
  };

  return {
    isLoading,
    isAuthorized: Boolean(accessToken),
    userData,
    userPreferences,
    userIsAdmin: isSuperAdmin,
    initializeAuth,
    logout,
  };
};
